

import { FC, useEffect } from 'react';

import { useFormatter } from '@eneco/i18n';
import { Text } from '@eneco/sparky';
import { useTracking } from '@eneco/tracking';

interface ReconcileAdvanceAmountDisclaimerProps {
  amount: number | null | undefined;
  recommendedAmountTooLowDisclaimerLabel: string;
  recommendedAmountTooHighDisclaimerLabel: string;
}

const ReconcileAdvanceAmountDisclaimer: FC<ReconcileAdvanceAmountDisclaimerProps> = ({
  amount,
  recommendedAmountTooLowDisclaimerLabel,
  recommendedAmountTooHighDisclaimerLabel,
}) => {
  const { format, currency } = useFormatter();
  const { trackEventBE } = useTracking();

  useEffect(() => {
    if (amount == null || amount === 0) {
      return;
    }
    trackEventBE('be_bbp_visible');
  }, [trackEventBE, amount]);

  if (amount == null || amount === 0) return null;

  if (amount < 0)
    return (
      <Text size="BodyM">
        {format(recommendedAmountTooLowDisclaimerLabel ?? '[not in sitecore {amount}]', {
          amount: currency.euroNoFractionDigits(Math.abs(amount)),
        })}
      </Text>
    );
  else
    return (
      <Text size="BodyM">
        {format(recommendedAmountTooHighDisclaimerLabel ?? '[not in sitecore {amount}]', {
          amount: currency.euroNoFractionDigits(amount),
        })}
      </Text>
    );
};

export default ReconcileAdvanceAmountDisclaimer;
